import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import findResult, { removeEmpty } from '@/utils/resultsHelper';
import { readStates } from '@/constants/lifecycle';
import useDebounce from '@/utils/debounce';
import DatasetCollectionsAssignAddRow from '../components/DatasetCollectionsAssignAddRow';
import {
  addDatasetCollectionsAssignable,
  fetchDatasetCollectionsAssignable,
  updateDatasetCollectionsAssignableProperties,
  updateDatasetUnassignedCollectionsProperties,
} from '../actions';

const DatasetCollectionAddRow = ({
  category,
  code,
  collections,
  collectionsToAdd,
  fetchData,
  updateFilter,
  updateProperties,
  addCollections,
  readStatus,
  filter,
}) => {
  const debouncedFetch = useDebounce(fetchData);

  const collectionsToAddChange = (value) => {
    const items = removeEmpty(value.map((c) => collections.find((item) => item.code === c)));
    updateProperties({ collectionsToAdd: items });
  };

  const onFilterChange = useCallback((value) => {
    updateFilter(category, code, value);
    debouncedFetch(category, code, value);
  }, [category, code, updateFilter, debouncedFetch]);

  return (
    <DatasetCollectionsAssignAddRow
      readStatus={readStatus}
      filter={filter}
      collections={collections}
      addCollections={() => addCollections(category, code)}
      onFilterChange={onFilterChange}
      collectionsToAdd={collectionsToAdd}
      collectionsToAddChange={collectionsToAddChange}
    />
  );
};

const dialogProps = (collectionAssigningDataset, exists, collections = []) => (
  {
    exists,
    collectionsToAdd: collectionAssigningDataset.collectionsToAdd,
    collections,
  }
);

const withoutItem = (collectionAssigningDataset) => (
  {
    ...dialogProps(collectionAssigningDataset, false),
    ...readStates,
    filter: '',
  }
);

const withItem = (item, collectionAssigningDataset) => {
  const assignable = item.unassignedCollections.results;

  return (
    {
      ...dialogProps(collectionAssigningDataset, true, assignable),
      readStatus: item.unassignedCollections.readStatus,
      readErrors: item.unassignedCollections.readErrors,
      filter: item.unassignedCollections.filter,
    }
  );
};

const mapStateToProps = ({
  datasetCollections: {
    datasetCollections,
    collectionAssigningDataset,
  },
}, { category, code }) => {
  const item = findResult(datasetCollections, category, code);
  return item ? withItem(item, collectionAssigningDataset) : withoutItem(collectionAssigningDataset);
};

const mapDispatchToProps = {
  addCollections: addDatasetCollectionsAssignable,
  fetchData: fetchDatasetCollectionsAssignable,
  updateFilter: (category, code, filter) => updateDatasetUnassignedCollectionsProperties(category, code, { filter }),
  updateProperties: updateDatasetCollectionsAssignableProperties,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatasetCollectionAddRow);
